module.exports = __webpack_public_path__ + "media/icons/1@2x-17018f85.png";